import { initComponents } from './componentHelpers'
import { getAnimationDuration, getTrasitionDuration } from './animationHelpers'
import { addClass, removeClass, hasClass } from './classHelpers'
import { PubSub } from './PubSub'

export default class Component {
  constructor (elem, APP) {
    this.elem = elem
    this.APP = APP
    this.transitioning = false
    this.events = new PubSub()
    this.setDefaultProps()
  }

  setDefaultProps () {
    let defaultProps = this.elem.getAttribute('data-component-props')
    if (defaultProps) {
      defaultProps = JSON.parse(defaultProps)
      for (let prop in defaultProps) {
        this[prop] = defaultProps[prop]
      }
    }
  }

  addClass (className, el = this.elem) {
    addClass(el, className)
    return this
  }

  removeClass (className, el = this.elem) {
    removeClass(el, className)
    return this
  }

  hasClass (className, el = this.elem) {
    return hasClass(el, className)
  }

  swapClass (currentClass, nextClass, el = this.elem) {
    removeClass(el, currentClass)
    addClass(el, nextClass)
    return this
  }

  transitionDuration (context = this.elem) {
    return getTrasitionDuration(context)
  }

  animationDuration (context = this.elem) {
    return getAnimationDuration(context)
  }

  addAnimationClass (animationClassName, el = this.elem) {
    addClass(el, animationClassName)
    addClass(el, '_is_transitioning')
    this.APP.state.isTransitioning = true
    let duration = getAnimationDuration(el)
    return new Promise(resolve => {
      removeClass(el, '_is_transitioning')
      this.APP.state.isTransitioning = false
      setTimeout(resolve.bind(this), duration)
    })
  }

  initComponents (context = this.elem) {
    initComponents(context, this.APP)
  }
}
